import apiList from "./apiList";
//eslint-disable-next-line
export default {
    apiList
}
